import Vue from 'vue'
import { ToastPlugin, ModalPlugin, BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import wysiwyg from 'vue-wysiwyg'
import VueMask from 'v-mask'

import router from './router'
import store from './store'
import App from './App.vue'
import logErrorToS3 from '@/libs/errorLogger'

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'
import '@/libs/quill-editor'
import '@/libs/vue-select'
import '@/libs/vue-ripple'
import '@/libs/dayjs'
import '@/libs/statusData'
import '@/libs/statusValue'
import '@/libs/ticketStatus'
import '@/libs/ticketValue'
import '@/libs/format-status'
import '@/libs/format-status-value'
import '@/libs/vee-validate'
import '@/libs/prototype'
import '@/libs/click-outside'
import '@/libs/permission'
import '@/libs/wrap-word'
import '@/libs/replacePhoneNumber'

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(wysiwyg, {})
Vue.use(VueMask)

// Composition API
Vue.use(VueCompositionAPI)

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

// 2. Set up the global error handler
// This will only run in production to avoid spamming during development.
console.log('ENV:', process.env.NODE_ENV);
if (process.env.NODE_ENV === 'production') {
  Vue.config.errorHandler = (err, vm, info) => {
    // Log the error to S3
    logErrorToS3(err, vm, info)

    // You can also log it to the console
    console.error('An error was caught and sent to logs:', err, info)
  }
}

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
